import { EntityBuilder } from '@decahedron/entity';
import { Talent } from 'packages/talent/entities/Talent';
import { TalentTimelineItem } from 'packages/talent/entities/TalentTimelineItem';
import axios from 'axios';
import Qs from 'qs';
// Singleton holder
var _instance = null;
var TalentService = /** @class */ (function () {
    function TalentService() {
        /**
         * The current selected talent
         *
         * @type Talent
         * @memberOf TalentService
         */
        this.talent = null;
        if (_instance) {
            return _instance;
        }
        _instance = this;
    }
    /**
     * Get a Talent
     * @returns {Promise} - Resolves with talent data.
     */
    TalentService.prototype.getTalent = function (talentId) {
        var _this = this;
        return axios.get("/api/v2/talent/" + talentId)
            .then(function (_a) {
            var data = _a.data;
            return _this.talent = EntityBuilder.buildOne(Talent, data.data);
        });
    };
    TalentService.prototype.getTimelineForTalent = function (talentId, paging) {
        return axios.get("/api/v2/talents/" + talentId + "/events?" + Qs.stringify(paging.queryData, { arrayFormat: 'indices', encode: false }))
            .then(function (_a) {
            var data = _a.data;
            return ({
                items: EntityBuilder.buildMany(TalentTimelineItem, data.data),
                pagination: data.pagination,
            });
        });
    };
    TalentService.prototype.sendMailToTalents = function (talents, subject, body, threadId, jobId, companyId) {
        var payload = {
            talent_ids: talents.map(function (talent) { return talent.id; }),
            subject: subject,
            body: body,
            thread_id: threadId,
            job_id: jobId,
            as_company: !!companyId,
            company_id: companyId,
        };
        return axios.post('/api/v2/mail/talent', payload);
    };
    TalentService.prototype.removeTag = function (talent, tag) {
        return axios.get("/api/v2/talent/" + talent.id + "/detach-tag/" + tag.id);
    };
    TalentService.prototype.attachTag = function (talent, tag) {
        return axios.get("/api/v2/talent/" + talent.id + "/attach-tag/" + tag.id);
    };
    return TalentService;
}());
export { TalentService };
